import React from "react";
import { sizes } from "styles";
import { Spacer } from "styles/common/spacer";
import { CardCarousel } from "..";
import { LockIcon } from "../assets/lock-icon";
import DownloadLockIcon from "public/assets/kelas-live/download-lock.svg";
import {
  LockIconWrapper,
  PastClassDetailsStudyMaterialCard,
  PastClassDetailStudyMaterialCardIcon,
  PastClassDetailStudyMaterialCardTitle,
  PastClassDetailStudyMaterialDownloadLink,
  PastClassDetailVideoThumbnail,
  PastClassDetailVideoThumbnailIcon,
  PastClassDetailVideoThumbnailWrapper
} from "./past-class-detail-modal.styles";
import { IVideoMaterialBlock } from "./past-class-detail-modal.types";
import { SubscriptionType } from "../../../services/api/sessions/sessionService.types";
import { useTrialActivationModal } from "../trial-activation-modal/use-trial-activation";
import { TrialActivationModal } from "../trial-activation-modal/trial-activation-modal";
import Image from "next/legacy/image";
import { Copy } from "components/icons/copy";
import { Play } from "components/icons/play";

const MultipleClassMaterialBlock: React.FC<IVideoMaterialBlock> = ({
  setSelectedVideo,
  baseMediaURL,
  currentDownloadingFile,
  downloadStudyMaterial,
  classSession,
  videoMaterials,
  canAccessStudyMaterial,
  subscriptionStatus,
  primaryUser
}) => {
  const { showTrialActivation, setShowTrialActivation } =
    useTrialActivationModal(primaryUser.access_token);
  return (
    <>
      {videoMaterials.length > 0 && (
        <CardCarousel title="Tonton video materi">
          {videoMaterials.map((video, idx) => (
            <div
              style={{ width: sizes.kelasLive.pastClassDetailModalVideo }}
              key={idx}
            >
              <PastClassDetailVideoThumbnailWrapper
                onClick={() => {
                  if (
                    subscriptionStatus.subscriptionType ===
                    SubscriptionType.FREE
                  ) {
                    setShowTrialActivation.on();
                  } else {
                    canAccessStudyMaterial && setSelectedVideo(video);
                  }
                }}
                canAccessStudyMaterial={canAccessStudyMaterial}
              >
                <PastClassDetailVideoThumbnail
                  src={`${baseMediaURL}/${video.thumbnailUrl}`}
                  alt={`video material for ${classSession.topic}`}
                />
                <PastClassDetailVideoThumbnailIcon
                  canAccessStudyMaterial={canAccessStudyMaterial}
                >
                  {canAccessStudyMaterial ||
                  subscriptionStatus.subscriptionType ===
                    SubscriptionType.FREE ? (
                    <Play />
                  ) : (
                    <LockIconWrapper>
                      <LockIcon width="30" height="30" />
                    </LockIconWrapper>
                  )}
                </PastClassDetailVideoThumbnailIcon>
              </PastClassDetailVideoThumbnailWrapper>
            </div>
          ))}
        </CardCarousel>
      )}
      <Spacer token={[16, 16, 32]} />
      {classSession.studyMaterialUrls &&
        classSession.studyMaterialUrls.length > 0 && (
          <CardCarousel title="Download materi kelas" isWidthFixed={true}>
            {classSession.studyMaterialUrls.map((studyMaterial, idx) => (
              <div
                style={{
                  width: sizes.kelasLive.pastClassDetailModalStudyMaterialCard
                }}
                key={idx}
              >
                <PastClassDetailsStudyMaterialCard>
                  <PastClassDetailStudyMaterialCardIcon>
                    <Copy />
                  </PastClassDetailStudyMaterialCardIcon>
                  <PastClassDetailStudyMaterialCardTitle>
                    {studyMaterial.fileName}
                  </PastClassDetailStudyMaterialCardTitle>
                  <PastClassDetailStudyMaterialDownloadLink
                    variant="primary"
                    isLoading={currentDownloadingFile === studyMaterial.url}
                    loadingText="Loading..."
                    onClick={() => {
                      if (
                        subscriptionStatus.subscriptionType ===
                        SubscriptionType.FREE
                      ) {
                        setShowTrialActivation.on();
                      } else {
                        downloadStudyMaterial(
                          `${baseMediaURL}/${studyMaterial.url}`,
                          studyMaterial.fileName
                        );
                      }
                    }}
                    disabled={
                      subscriptionStatus.subscriptionType ===
                      SubscriptionType.FREE
                        ? false
                        : !canAccessStudyMaterial
                    }
                  >
                    {subscriptionStatus.subscriptionType ===
                      SubscriptionType.FREE_AFTER_PAID ||
                    subscriptionStatus.subscriptionType ===
                      SubscriptionType.FREE_AFTER_TRIAL ||
                    subscriptionStatus.subscriptionType ===
                      SubscriptionType.PAUSED ? (
                      <Image src={DownloadLockIcon} alt="Download" />
                    ) : null}{" "}
                    Download
                  </PastClassDetailStudyMaterialDownloadLink>
                </PastClassDetailsStudyMaterialCard>
              </div>
            ))}
          </CardCarousel>
        )}
      {showTrialActivation && (
        <TrialActivationModal
          onClose={() => {
            setShowTrialActivation.off();
          }}
          primaryUser={primaryUser}
          subscriptionStatus={subscriptionStatus}
        />
      )}
    </>
  );
};

export { MultipleClassMaterialBlock };
